import React from 'react';

import Modal from '~components/Modal';

import { Supplement } from '~lookups/models';

import BudgetSupplements from './BudgetSupplements';

interface ComponentProps {
  isOpen?: boolean;
  setIsOpen: (toggle: boolean) => void;
  value: { supplements: Supplement[]; package_fixed_id?: number };
  onChange?: (name: string, value: any) => void;
}

const BudgetSupplementsModal: React.FC<ComponentProps> = ({ value, onChange, isOpen, setIsOpen }) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} header="Edit Budget Supplements" headerClassName="header" size="lg">
      <BudgetSupplements
        type="custom"
        id="supplements"
        name="supplements"
        value={value}
        onChange={onChange}
        layout="stack"
      />
    </Modal>
  );
};

export default BudgetSupplementsModal;
